import { Mapper, MapperPipe } from './mapper.pipe';

export { MapperPipe, Mapper };
